/**
 * Payment Term API Service
 * Service layer for payment term-related API calls
 *
 * Note: This service is for payment term templates only.
 * Vendor-specific payment data is handled by payment.api.ts
 */

import apiClient from './axios.config';
import type { PaymentTermsResponse } from '@/types/api/paymentTerm';

/**
 * Payment Term API service object
 */
export const paymentTermApi = {
  /**
   * GET /api/payment-terms
   * Get all payment terms (base templates)
   * @param typeId - Payment term type ID (1=Vendor, 2=Customer)
   */
  list: async (typeId: 1 | 2): Promise<PaymentTermsResponse> => {
    const response = await apiClient.get<PaymentTermsResponse>('/payment-terms', {
      params: { typeId },
    });
    return response.data;
  },
};

export default paymentTermApi;
